import React from 'react'
import HereNativeRouteMap from '../HereMaps/HereNativeRouteMap'

interface LatLng {
  latitude: number
  longitude: number
}

interface Stop {
  latitude: number
  longitude: number
}

interface DirectionsMapProps {
  origin?: LatLng
  destination?: LatLng
  additionalStops?: Stop[]
  mapWidth?: string
  mapHeight?: string
  marginLeft?: string
  marginRight?: string
  updateRouteInfo?: (info: any) => void
  mapOptions?: {
    zoomControl?: boolean
    scrollWheelZoom?: boolean
    dragging?: boolean
    doubleClickZoom?: boolean
    touchZoom?: boolean
    zoomLevel?: number
  }
  borderRadius?: string
  boxShadow?: string
}

function DirectionsMap(props: DirectionsMapProps) {
  return <HereNativeRouteMap {...props} />
}

function areEqual(prev: DirectionsMapProps, next: DirectionsMapProps) {
  return JSON.stringify(prev) === JSON.stringify(next)
}

export default React.memo(DirectionsMap, areEqual)
